import { render, staticRenderFns } from "./QualityMetricsIC.vue?vue&type=template&id=30764760&scoped=true&"
import script from "./QualityMetricsIC.vue?vue&type=script&lang=js&"
export * from "./QualityMetricsIC.vue?vue&type=script&lang=js&"
import style0 from "./QualityMetricsIC.vue?vue&type=style&index=0&id=30764760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30764760",
  null
  
)

export default component.exports